<template>
  <form>
    <div>
      <div class="row">
        <InfoBox v-if="value['error']">
          <span>{{ getInfoText }}</span>
        </InfoBox>
      </div>
      <div class="file-input-container">
        <button @click="clickInput" class="zord-btn btn zord-btn-primary btn-primary select-file-button" :class="{'btn-success': file.name}">Wybierz plik</button>
        <label class="file-input-label">
          <input
            style="display: none"
            id="file"
            ref="file"
            type="file"
            @change="handleFileUpload"
          >
          <span v-if="file">{{file.name}}</span>
        </label>
      </div>
      <blocking-loader
        :show="getLoadingUsersImport"
      >
        Trwa import dokumentów danych użytkowników
      </blocking-loader>
    </div>
  </form>
</template>

<script>
  import FormModalValidation from '../../../../../../../src/components/share//form/FormModalValidation';
  import Loader from '../../../../../../../src/components/share/Loader';
  import InfoBox from '../../../../../../../src/components/share/InfoText/InfoBox';
  import BlockingLoader from '../../../../../../../src/components/share/BlockingLoader';
  import { mapGetters } from "vuex";

  export default {
    components: {
      InfoBox,
      BlockingLoader
    },
    mixins: [
      FormModalValidation,
      Loader
    ],
    props: {
      value: {}
    },
    data () {
      return {
        info: {},
        file: {}
      }
    },
    computed: {
    ...mapGetters(['getLoadingUsersImport']),
      getInfoText () {
        let columnsMap = {
          default: ['A', 'B', 'C', 'Z']
        }

        return `Importowany musi zawierać imię w kolumnie "${columnsMap.default[0]}", nazwisko w kolumnie "${columnsMap.default[1]}", e-mail w kolumnie "${columnsMap.default[2]}", telefon w kolumnie "${columnsMap.default[3]}".`

      }
    },
    methods: {
      clickInput(e) {
        e.preventDefault()
        this.$refs.file.click()
      },
      handleFileUpload (e) {
        if (this.$refs.file.files[0]) {
          this.value.file = this.$refs.file.files[0]
          this.file = this.$refs.file.files[0]
        } else {
          this.value.file = {}
          this.file = {}
        }
      }
    }
  }
</script>
<style scoped>
  .select-file-button {
    width: 100px;
    height: 30px;
    margin: 5px;
  }
  .file-input-container {
    display: flex;
  }
  .file-input-label {
    padding: 10px 0 0 0;
  }
</style>
